import React from "react";
import "./Button.scss"
const Button = ({ text, Secondary, onClick, isLoading }) => {
    return (
        <div className={`Button ${Secondary ? "Secondary" : ""}`} onClick={onClick}>
            {isLoading && <div className="Jack-btn-loader " />} {text}
        </div>)
}
export default Button